/**
 * Backup Utilities
 * ================
 * One-click backup download for LHS Command Centre.
 */

const API_URL = process.env.REACT_APP_BACKEND_URL || '';
const BACKUP_KEY = process.env.REACT_APP_BACKUP_KEY || 'lhs-backup-2024-secure';

/**
 * Download full system backup as JSON file.
 * Uses existing auth token + admin key.
 */
export async function downloadSystemBackup(setLoading) {
  try {
    if (setLoading) setLoading(true);
    
    const token =
      localStorage.getItem("lhs_token") ||
      localStorage.getItem("token") ||
      localStorage.getItem("access_token");

    if (!token) {
      alert("No auth token found. Please log in again.");
      return false;
    }

    const res = await fetch(`${API_URL}/api/admin/backup?include_activity=true`, {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${token}`,
        "x-admin-key": BACKUP_KEY
      }
    });

    if (!res.ok) {
      const text = await res.text();
      throw new Error(text || "Backup failed");
    }

    const data = await res.json();

    // Generate filename with timestamp
    const fileName =
      "lhs-backup-" +
      new Date().toISOString().slice(0, 19).replace(/:/g, "-") +
      ".json";

    // Create and download blob
    const blob = new Blob([JSON.stringify(data, null, 2)], {
      type: "application/json"
    });

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);

    return true;
  } catch (err) {
    console.error("Backup error:", err);
    alert("Backup failed: " + (err.message || "Check console for details"));
    return false;
  } finally {
    if (setLoading) setLoading(false);
  }
}

/**
 * Get backup status (last backup time, recommendation)
 */
export async function getBackupStatus() {
  try {
    const token =
      localStorage.getItem("lhs_token") ||
      localStorage.getItem("token") ||
      localStorage.getItem("access_token");

    if (!token) return null;

    const res = await fetch(`${API_URL}/api/admin/backup-status`, {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${token}`
      }
    });

    if (!res.ok) return null;

    const data = await res.json();
    return data.data;
  } catch (err) {
    console.error("Backup status error:", err);
    return null;
  }
}

export default { downloadSystemBackup, getBackupStatus };
